"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("@material/button/dist/mdc.button.css");

require("@rmwc/icon/styles");

require("@rmwc/ripple/styles");